export const NewAccount = {
    Title: 'Create account',
    RegistrationProcessSpinner:
    {
        InitialText: 'Creating account...',
        UploadingAvatar: 'Uploading profile picture...',
        SendingStripeToken: 'Linking your card...',
    },
    ConfirmDialog: {
        BtnOkText: 'Ok',
        title: 'User was successfully registered',
        content: 'Now you will be transferred to main page'
    },
    BottomButton: {
        NextLabel: 'Next',
        CreateLabel: 'Create Account'
    },
    BottomActions: {
        BusinessSignUp: 'Business Customer Sign Up',
        SkipCreditCard: 'Skip and Create Account'
    },
    PaymentInformation:
    {
        Label: 'Payment Information',
        TopInfoText: 'Payment information is needed for you to publish jobs for bids.',
        TopInfoText2: 'A charge is only made if you accept a bid.',
        Widgets:
        {
            CardNumber: {
                placeholder: 'Payment Card Number'
            },
            ExpirationDate: {
                placeholder: 'MM/YY'
            },
            CVV: {
                placeholder: 'CVV'
            }
        }
    },
    PersonalInfo:
    {
        Label: 'Personal Information',
        Widgets:
        {
            Avatar: {
                placeholder: 'Click here to select an avatar'
            },
            FirstName: {
                placeholder: 'First Name'
            },
            LastName: {
                placeholder: 'Last Name'
            },
            Email: {
                placeholder: 'Email'
            },
            Phone: {
                placeholder: 'Phone'
            },
            ZipCode: {
                placeholder: 'Zip Code'
            },
            Password: {
                placeholder: 'Password'
            },
            PasswordConformation: {
                placeholder: 'Re-enter your password'
            }
        }
    },
    Errors: {
        Messages: {
            Avatar: 'Please select a profile picture.',
            FirstName: 'Please enter your first name.',
            LastName: 'Please enter your last name.',
            Email: 'Please enter your email address.',
            Password: 'Password should be 8 characters long and contain a number.',
            ConfirmPassword: 'Passwords do not match.',
            Phone: 'Please enter a valid telephone number.',
            ZipCode: 'Please enter a valid zip Code.',

            CardNumber: 'Card number is invalid',
            ExpirationDate: 'Expire date is invalid. Enter with format: \'MM/YY\'',
            CVV: 'CVV is invalid'
        }
    }
}



// WEBPACK FOOTER //
// ./src/localization/NewAccount.ts